module.exports = __webpack_public_path__ + "img/tutorial-pole.605b647a.webp";